import * as PlaybackStateActions from "actions/PlaybackStateActions";
import getDuration from "selectors/chapter/getDuration";
import getIsProgressBarProgressHidden from "selectors/chapter/getIsProgressBarProgressHidden";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import MobileChapterControlsSlider from "components/MobileChapterControls/MobileChapterControlsSlider";
import { connect } from "react-redux";
import { WithSliderDimensions, WithSetSliderRef } from "context/Slider";
import { compose, fromRenderProps } from "recompose";

const mapStateToProps = (state, ownProps) => {
  const playbackState = getPlaybackState(state, ownProps);
  return {
    duration: getDuration(state, ownProps),
    hideProgressBarProgress: getIsProgressBarProgressHidden(state, ownProps),
    scrubbing: playbackState.scrubbing,
    time: playbackState.time,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onScrubStart: () =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        scrubbing: true,
        playing: false,
      }),
    ),
  onSeek: (time) =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        time,
      }),
    ),
  onScrubEnd: () =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        scrubbing: false,
        playing: true,
      }),
    ),
  seekForward() {
    dispatch(PlaybackStateActions.seekForward(ownProps));
  },
  seekBack() {
    dispatch(PlaybackStateActions.seekBack(ownProps));
  },
});

export default compose(
  fromRenderProps(WithSliderDimensions, ({ sliderDimensions }) => ({
    sliderLeft: sliderDimensions.left,
    sliderWidth: sliderDimensions.width,
  })),
  fromRenderProps(WithSetSliderRef, ({ setSliderRef }) => ({ setSliderRef })),
  connect(mapStateToProps, mapDispatchToProps),
)(MobileChapterControlsSlider);
